import type { ComponentProps } from 'react';

type Props = {
  variant?: 'muted' | 'active' | 'primary' | 'fill';
} & ComponentProps<'svg'>;

export const OrganizationIcon = ({ variant = 'primary', ...rest }: Props) => {
  switch (variant) {
    case 'muted':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="none"
          viewBox="0 0 24 24"
          {...rest}
        >
          <g className="muted__color=muted">
            <g className="muted__Group">
              <path
                fill="#646467"
                d="M8.3 5H4.7a1.2 1.2 0 0 0-1.2 1.2v3.6A1.2 1.2 0 0 0 4.7 11h3.6a1.2 1.2 0 0 0 1.2-1.2V9H11v8.5h3.994v-2H13V9h1.5v.8a1.2 1.2 0 0 0 1.2 1.2h3.6a1.2 1.2 0 0 0 1.2-1.2V6.2A1.2 1.2 0 0 0 19.3 5h-3.6a1.2 1.2 0 0 0-1.2 1.2V7h-5v-.8A1.2 1.2 0 0 0 8.3 5Z"
                className="muted__Vector"
              />
              <path
                fill="#646467"
                d="M19.3 13.5h-3.6a1.2 1.2 0 0 0-1.2 1.2v3.6a1.2 1.2 0 0 0 1.2 1.2h3.6a1.2 1.2 0 0 0 1.2-1.2v-3.6a1.2 1.2 0 0 0-1.2-1.2Z"
                className="muted__active"
              />
            </g>
          </g>
        </svg>
      );
    case 'active':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="none"
          viewBox="0 0 24 24"
          {...rest}
        >
          <g className="active__color=active">
            <g className="active__Group">
              <path
                fill="#646467"
                d="M8.3 5H4.7a1.2 1.2 0 0 0-1.2 1.2v3.6A1.2 1.2 0 0 0 4.7 11h3.6a1.2 1.2 0 0 0 1.2-1.2V9H11v8.5h3.994v-2H13V9h1.5v.8a1.2 1.2 0 0 0 1.2 1.2h3.6a1.2 1.2 0 0 0 1.2-1.2V6.2A1.2 1.2 0 0 0 19.3 5h-3.6a1.2 1.2 0 0 0-1.2 1.2V7h-5v-.8A1.2 1.2 0 0 0 8.3 5Z"
                className="active__Vector"
              />
              <path
                fill="#546195"
                d="M19.3 13.5h-3.6a1.2 1.2 0 0 0-1.2 1.2v3.6a1.2 1.2 0 0 0 1.2 1.2h3.6a1.2 1.2 0 0 0 1.2-1.2v-3.6a1.2 1.2 0 0 0-1.2-1.2Z"
                className="active__active"
              />
            </g>
          </g>
        </svg>
      );
    case 'primary':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="none"
          viewBox="0 0 24 24"
          {...rest}
        >
          <g className="primary__color=primary">
            <g className="primary__Group">
              <path
                fill="#1D2445"
                d="M8.3 5H4.7a1.2 1.2 0 0 0-1.2 1.2v3.6A1.2 1.2 0 0 0 4.7 11h3.6a1.2 1.2 0 0 0 1.2-1.2V9H11v8.5h3.994v-2H13V9h1.5v.8a1.2 1.2 0 0 0 1.2 1.2h3.6a1.2 1.2 0 0 0 1.2-1.2V6.2A1.2 1.2 0 0 0 19.3 5h-3.6a1.2 1.2 0 0 0-1.2 1.2V7h-5v-.8A1.2 1.2 0 0 0 8.3 5Z"
                className="primary__Vector"
              />
              <path
                fill="#1D2445"
                d="M19.3 13.5h-3.6a1.2 1.2 0 0 0-1.2 1.2v3.6a1.2 1.2 0 0 0 1.2 1.2h3.6a1.2 1.2 0 0 0 1.2-1.2v-3.6a1.2 1.2 0 0 0-1.2-1.2Z"
                className="primary__active"
              />
            </g>
          </g>
        </svg>
      );
    case 'fill':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="none"
          viewBox="0 0 24 24"
          {...rest}
        >
          <g className="primary-on-fill__color=primary_on_fill">
            <g className="primary-on-fill__Group">
              <path
                fill="#fff"
                d="M8.3 5H4.7a1.2 1.2 0 0 0-1.2 1.2v3.6A1.2 1.2 0 0 0 4.7 11h3.6a1.2 1.2 0 0 0 1.2-1.2V9H11v8.5h3.994v-2H13V9h1.5v.8a1.2 1.2 0 0 0 1.2 1.2h3.6a1.2 1.2 0 0 0 1.2-1.2V6.2A1.2 1.2 0 0 0 19.3 5h-3.6a1.2 1.2 0 0 0-1.2 1.2V7h-5v-.8A1.2 1.2 0 0 0 8.3 5Z"
                className="primary-on-fill__Vector"
              />
              <path
                fill="#fff"
                d="M19.3 13.5h-3.6a1.2 1.2 0 0 0-1.2 1.2v3.6a1.2 1.2 0 0 0 1.2 1.2h3.6a1.2 1.2 0 0 0 1.2-1.2v-3.6a1.2 1.2 0 0 0-1.2-1.2Z"
                className="primary-on-fill__active"
              />
            </g>
          </g>
        </svg>
      );
  }
};
